import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslatePipe } from '@ngx-translate/core'

import { EditorThread } from '../../editor-thread.types'
import { SuggestionTextRun } from '../../extensions/track-changes-utils'
import { SuggestionMetaComponent } from '../../suggestion-meta/suggestion-meta.component'
import { ThreadCommentsComponent, ThreadCommentsCurrentUser } from '../thread-comments/thread-comments.component'

export type SuggestionCardVariant = 'added' | 'removed' | 'replaced' | 'formatting'

@Component({
  selector: 'app-suggestion-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslatePipe, SuggestionMetaComponent, ThreadCommentsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './suggestion-card.component.html',
  styleUrl: './suggestion-card.component.scss',
})
export class SuggestionCardComponent {
  @Input({ required: true })
  suggestionId!: string

  @Input({ required: true })
  variant!: SuggestionCardVariant

  @Input({ required: true })
  authorName!: string

  @Input()
  createdAtRelative: string | null = null

  @Input()
  insertionRuns: SuggestionTextRun[] = []

  @Input()
  deletionRuns: SuggestionTextRun[] = []

  @Input()
  formattingText = ''

  @Input()
  structureText = ''

  @Input({ required: true })
  canResolve!: boolean

  @Input()
  highlighted = false

  @Input()
  thread: EditorThread | null = null

  @Input({ required: true })
  currentUser!: ThreadCommentsCurrentUser

  @Input()
  canPostComment = true

  @Output()
  accept = new EventEmitter<string>()

  @Output()
  reject = new EventEmitter<string>()

  @Output()
  view = new EventEmitter<string>()

  @Output()
  submitComment = new EventEmitter<string>()

  onAccept() {
    this.accept.emit(this.suggestionId)
  }

  onReject() {
    this.reject.emit(this.suggestionId)
  }

  onView() {
    this.view.emit(this.suggestionId)
  }

  onCardClick(event: MouseEvent) {
    const target = event.target as HTMLElement | null
    if (target?.closest('button, input, textarea, a, select, label, [contenteditable="true"]')) {
      return
    }
    this.onView()
  }

  onSubmitComment(body: string) {
    this.submitComment.emit(body)
  }
}
